// This browser's own preferences (never records): the current user of the dev switcher (no login yet, the auth
// layer replaces this later, as the kit did), light / dark, the sidebar on a phone.
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Role } from '@/types'

export const PERMISSIONS: Record<Role, string[]> = {
  // code.*: editors edit and test, admins build and make live (LH-F2, the playground's rules card)
  admin: ['lenders.view', 'lenders.edit', 'lenders.activate', 'gateway.view', 'gateway.edit', 'gateway.test', 'gateway.manage', 'code.view', 'code.edit', 'code.test', 'code.publish', 'alerts.view', 'alerts.manage', 'users.manage', 'settings.manage', 'app.edit', 'app.check', 'app.status', 'mis.upload', 'mis.settings'],
  editor: ['lenders.view', 'lenders.edit', 'gateway.view', 'gateway.edit', 'gateway.test', 'code.view', 'code.edit', 'code.test', 'alerts.view', 'app.edit'],
  reviewer: ['lenders.view', 'gateway.view', 'gateway.test', 'code.view', 'code.test', 'alerts.view', 'app.check'],
  analyst: ['lenders.view', 'gateway.view', 'code.view', 'alerts.view'],
  // HM2: the lenders' MIS only
  mis_uploader: ['mis.upload'],
}

interface DevState {
  currentUserId: string
  colourScheme: 'light' | 'dark'
  sidebarOpen: boolean
  setCurrentUser: (id: string) => void
  setColourScheme: (s: 'light' | 'dark') => void
  setSidebarOpen: (open: boolean) => void
}

export const useDevStore = create<DevState>()(
  persist(
    (set) => ({
      currentUserId: 'u_asha',
      colourScheme: 'light',
      sidebarOpen: false,
      setCurrentUser: (currentUserId) => set({ currentUserId }),
      setColourScheme: (colourScheme) => set({ colourScheme }),
      setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
    }),
    { name: 'lender-hub-portal-dev' },
  ),
)
